window.addEventListener("load", async () => {

    /*=====================================================
        ELEMENTS
    =====================================================*/

    const selectedContainer = document.getElementById("selected-accords");
    const clearButton = document.getElementById("clear-accords-btn");
    const searchInput = document.getElementById("accord-search");
    const resultsBox = document.getElementById("accord-search-results");

    const accordFinderView = document.getElementById("finder-view");
    const resultsView = document.getElementById("results-view");

    const searchButton = document.getElementById("search-accords-btn");
    const backButton = document.getElementById("back-to-search-btn");



    /*=====================================================
        DATA
    =====================================================*/

    let allAccords = [];
    let allProducts = [];

    let selectedAccords =
        JSON.parse(localStorage.getItem("selectedAccords")) || [];



    /*=====================================================
        URL PARAMETERS
    =====================================================*/

    const params = new URLSearchParams(window.location.search);

    const clickedAccord = params.get("accord");

    if (clickedAccord) {

        if (backButton)
            backButton.style.display = "none";

        selectedAccords = [clickedAccord];

        localStorage.removeItem("selectedAccords");
        localStorage.setItem(
            "selectedAccords",
            JSON.stringify(selectedAccords)
        );

        sessionStorage.setItem(
            "accordFinderView",
            "results"
        );

    }



    /*=====================================================
        LOAD ACCORDS
    =====================================================*/


    async function fetchSampleProducts() {
        const products = [];
        const root = window.Shopify?.routes?.root || '/';
        for (let page = 1; page <= 100; page++) {
            const url = `${root}collections/all?section_id=pl-finder-data&page=${page}`;
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Finder data unavailable (HTTP ' + response.status + ')');
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const payload = doc.querySelector('[data-pl-finder-payload]');
            if (!payload) throw new Error('Finder data section is missing');
            const data = JSON.parse(payload.textContent);
            if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) {
                throw new Error('Finder data response is malformed');
            }
            // The collection already selects samples; verify tags again before rendering.
            const eligible = data.products.filter(product =>
                Array.isArray(product.tags) &&
                product.tags.includes('sample') &&
                !product.tags.includes('full-bottle')
            );
            for (const product of eligible) {
                if (!products.some(existing => existing.handle === product.handle)) {
                    products.push(product);
                }
            }
            if (page >= data.pages) return products;
        }
        throw new Error('Finder data exceeds pagination safety limit');
    }


    async function loadAccords() {
        // Populated from the sample-only fragrance dataset in loadProducts.
    }

    async function loadProducts() {
        try {
            const records = await fetchSampleProducts();
            allProducts = records.map(product => ({
                title: product.title,
                handle: product.handle,
                image: product.image || '',
                accords: Array.isArray(product.accords) ? product.accords : []
            }));
            const accordMap = new Map();
            for (const product of allProducts) {
                for (const accord of product.accords) {
                    if (accord.name && !accordMap.has(accord.name)) {
                        accordMap.set(accord.name, {
                            name: accord.name,
                            color: accord.color || '#cccccc',
                            image: accord.image || ''
                        });
                    }
                }
            }
            allAccords = [...accordMap.values()]
                .sort((a, b) => a.name.localeCompare(b.name));
        } catch (error) {
            console.error('Could not load sample fragrances for Find by Accords', error);
            const resultsCount = document.querySelector('.results-count');
            if (resultsCount) resultsCount.textContent = 'Unable to load fragrances. Please refresh the page.';
            throw error;
        }
    }

    function updateAccordCounts() {

    const counts = {};

    allProducts.forEach(product => {

        product.accords.forEach(accord => {

            counts[accord.name] = (counts[accord.name] || 0) + 1;

        });

    });

    document.querySelectorAll(".accord-fragrance-count").forEach(element => {

        const accord = element.dataset.accord;

        const count = counts[accord] || 0;

        element.textContent =
            `${count} fragrance${count === 1 ? "" : "s"}`;

    });

}

    /*=====================================================
        SEARCH
    =====================================================*/

    function searchPerfumes(){

        console.log("Searching...");
        console.log(selectedAccords);
        console.log(allProducts.length);
        const matchType =
            document.querySelector(
                'input[name="match"]:checked'
            ).value;

        let results = [];

        allProducts.forEach(product=>{

            const matchedAccords =
                selectedAccords.filter(selected=>

                    product.accords.some(
                        accord =>
                        accord.name===selected
                    )

                );

            if(

                (matchType==="or" &&
                matchedAccords.length>0)

                ||

                (matchType==="and" &&
                matchedAccords.length===selectedAccords.length)

            ){

                const totalIntensity =
    product.accords
        .filter(a => matchedAccords.includes(a.name))
        .reduce((sum, a) => sum + a.intensity, 0);

const score = Math.round(
    totalIntensity / selectedAccords.length
);

                results.push({

                    ...product,

                    matchedAccords,

                    score

                });

            }

        });

        results.sort(

            (a,b)=>b.score-a.score

        );

        renderResults(results);

    }

    /*=====================================================
    RENDER RESULTS
=====================================================*/

function renderResults(results){

    const resultsGrid =
        document.querySelector(".perfume-results-grid");

    const resultsCount =
        document.querySelector(".results-count");

    const resultsTitle =
        document.getElementById("results-title");

    resultsGrid.innerHTML = "";

    if(selectedAccords.length===1){

        resultsTitle.textContent =
            `Matching Fragrances with "${selectedAccords[0]}"`;

    }
    else{

        resultsTitle.textContent =
            "Matching Fragrances";

    }

    resultsCount.innerHTML =
        `<h4>${results.length} fragrances found</h4>`;


    results.forEach(product=>{

        const matchedAccords =
            product.accords.filter(a=>

                product.matchedAccords.includes(a.name)

            );

        resultsGrid.innerHTML += `

<a href="/products/${product.handle}"
class="perfume-result-card">

    <img
        src="${product.image}"
        alt="${product.title}"
    >

    <h4>${product.title}</h4>



    <div class="perfume-matched-accords">

        ${matchedAccords.map(accord=>`

            <div class="matched-accord">

                <div class="matched-accord-label">

                    ${accord.name}

                </div>

                <div class="matched-accord-track">

                    <div
                        class="matched-accord-fill"

                        style="
                            background:${accord.color};
                            width:${Math.max(
                                accord.intensity,
                                12
                            )}%;
                        ">

                    </div>

                </div>

            </div>

        `).join("")}

    </div>

    <div class="view-product">

        View Product →

    </div>

</a>

`;

    });

}



/*=====================================================
    SAVE SELECTION
=====================================================*/

function saveSelectedAccords(){

    localStorage.setItem(

        "selectedAccords",

        JSON.stringify(selectedAccords)

    );

}



/*=====================================================
    REFRESH SELECTED CHIPS
=====================================================*/

function refreshSelectedAccords(){

    selectedContainer.innerHTML = "";

    if(selectedAccords.length===0){

        selectedContainer.innerHTML =
        '<span class="selected-placeholder">No accords selected</span>';

        return;

    }

    selectedAccords.forEach(accord=>{

        const chip =
            document.createElement("div");

        chip.className =
            "selected-chip";

        chip.innerHTML = `

            ${accord}

            <button type="button">×</button>

        `;

        chip.querySelector("button")
        .addEventListener("click",()=>{

            selectedAccords =
                selectedAccords.filter(

                    a=>a!==accord

                );

            saveSelectedAccords();

            const card =
                document.querySelector(

                    `.accord-card[data-accord="${accord}"]`

                );

            if(card){

                card.classList.remove("selected");

            }

            refreshSelectedAccords();

        });

        selectedContainer.appendChild(chip);

    });

}



/*=====================================================
    ACCORD CARD CLICK
=====================================================*/

document.querySelectorAll(".accord-card").forEach(card=>{

    const accord =
        card.dataset.accord;

    if(selectedAccords.includes(accord)){

        card.classList.add("selected");

    }

    card.addEventListener("click",()=>{

        if(card.classList.contains("selected")){

            card.classList.remove("selected");

            selectedAccords =
                selectedAccords.filter(

                    a=>a!==accord

                );

        }
        else{

            card.classList.add("selected");

            if(!selectedAccords.includes(accord)){

                selectedAccords.push(accord);

            }

        }

        saveSelectedAccords();

        refreshSelectedAccords();

    });

});



/*=====================================================
    CLEAR BUTTON
=====================================================*/

clearButton.addEventListener("click", () => {

    selectedAccords = [];

    saveSelectedAccords();

    document.querySelectorAll(".accord-card.selected")
        .forEach(card => card.classList.remove("selected"));

    refreshSelectedAccords();

    searchInput.value = "";

    resultsBox.innerHTML = "";

    resultsBox.style.display = "none";

});


/*=====================================================
    SEARCH AUTOCOMPLETE
=====================================================*/

searchInput.addEventListener("input", () => {

    const search =
        searchInput.value.trim().toLowerCase();

    resultsBox.innerHTML = "";

    if (search.length < 2) {

        resultsBox.style.display = "none";

        return;

    }

    const matches = allAccords

        .filter(accord =>
            accord.name.toLowerCase().includes(search)
        )

        .filter(accord =>
            !selectedAccords.includes(accord.name)
        )

        .slice(0,10);

    if (matches.length === 0) {

        resultsBox.style.display = "none";

        return;

    }

    matches.forEach(accord => {

        const item = document.createElement("div");

        item.className = "accord-search-item";

        item.innerHTML = `

            <span
                style="
                    display:inline-block;
                    width:12px;
                    height:12px;
                    border-radius:50%;
                    background:${accord.color};
                    margin-right:8px;
                ">
            </span>

            ${accord.name}

        `;

        item.addEventListener("click", () => {

            if (!selectedAccords.includes(accord.name)) {

                selectedAccords.push(accord.name);

            }

            saveSelectedAccords();

            const card = document.querySelector(
                `.accord-card[data-accord="${accord.name}"]`
            );

            if (card) {

                card.classList.add("selected");

            }

            refreshSelectedAccords();

            searchInput.value = "";

            resultsBox.innerHTML = "";

            resultsBox.style.display = "none";

        });

        resultsBox.appendChild(item);

    });

    resultsBox.style.display = "block";

});


/*=====================================================
    BUTTONS
=====================================================*/

searchButton.addEventListener("click", () => {

    searchPerfumes();

    sessionStorage.setItem(
        "accordFinderView",
        "results"
    );

    accordFinderView.style.display = "none";

    resultsView.style.display = "block";

});


backButton.addEventListener("click", () => {

    sessionStorage.setItem(
        "accordFinderView",
        "finder"
    );

    resultsView.style.display = "none";

    accordFinderView.style.display = "block";

});


/*=====================================================
    INITIALISE
=====================================================*/

const savedView =
    sessionStorage.getItem("accordFinderView");

if (savedView === "results") {

    accordFinderView.style.display = "none";

    resultsView.style.display = "block";

}
else {

    accordFinderView.style.display = "block";

    resultsView.style.display = "none";

}

await loadAccords();

await loadProducts();

updateAccordCounts();

refreshSelectedAccords();

if (clickedAccord || savedView === "results") {

    searchPerfumes();

    accordFinderView.style.display = "none";

    resultsView.style.display = "block";

}

});